import { Controller } from "stimulus";
import { debounce, getCSRFToken } from "../../util";
import { trackEvent } from "../../util/analytics";
import { SELECT_ADD_PORTFOLIO_NFT_CTA } from "../../constants/mixpanel_config";
import { getSkeletonTemplate } from "../../template/search/section_templates";
import { EventCheckUserLogin } from "../../constants/events";

const NUM_TRENDING_NFTS = 7;

export default class extends Controller {
  static targets = ["searchInput", "searchResultsContainer", "trendingResultsContainer", "loading"];

  // We use this variable to prevent race conditions from AJAX calls
  // completing at different times.
  _ajaxCount = 0;


  async connect() {
    window.addEventListener(EventCheckUserLogin, async(e) => {
      this.userLoggedIn = e.detail.userLoggedIn;

      if (this.userLoggedIn) {
        await this._fetchPortfolioData();
        await this.renderTrendingNfts();

        this.handleSearchInput = debounce(this._handleSearchInput.bind(this), 300);
      }
    });
  }

  async _fetchPortfolioData() {
    const url = `/${I18n.locale}/nft-portfolios/portfolio_data`;
    await fetch(url, { credentials: "same-origin" })
      .then(response => response.text())
      .then(result => {
        if (!result) {
          return;
        }

        const data = JSON.parse(result)
        this.nftPortfolioId = +data.nft_portfolio_id;
        this.nftContractIds = data.nft_contract_ids.map(id => +id);
      });
  }

  async renderTrendingNfts() {
    this.trendingResultsContainerTarget.innerHTML = getSkeletonTemplate(NUM_TRENDING_NFTS, 1);

    const url = `/${I18n.locale}/nft-portfolios/trending_nfts`;
    await fetch(url, { credentials: "same-origin" })
      .then(response => response.text())
      .then(result => {
        if (!result) {
          return;
        }

        this.trendingResultsContainerTarget.innerHTML = result;
      });
  }

  _handleSearchInput() {
    const query = this.searchInputTarget.value;

    this._ajaxCount += 1;
    const ajaxCount = this._ajaxCount;

    if (!query) {
      this.trendingResultsContainerTarget.classList.remove("tw-hidden");
      this.searchResultsContainerTarget.classList.add("tw-hidden");
      this.loadingTarget.classList.add("!tw-hidden");

      return;
    }

    this.loadingTarget.classList.remove("!tw-hidden");


    const params = new URLSearchParams();
    params.set("query", query);

    const url = `/${I18n.locale}/nft-portfolios/${this.nftPortfolioId}/search?${params}`;
    fetch(url, { credentials: "same-origin" })
      .then(response => response.text())
      .then(result => {
        if (!result || this._ajaxCount !== ajaxCount) {
          return;
        }

        this.trendingResultsContainerTarget.classList.add("tw-hidden");
        this.searchResultsContainerTarget.innerHTML = result;
        this.searchResultsContainerTarget.classList.remove("tw-hidden");
        this.loadingTarget.classList.add("!tw-hidden");
      });
  }

  handleNft(e) {
    const nftContractId = e.currentTarget.dataset.nftContractId;
    let nftSlug = e.currentTarget.getAttribute("data-nft-contract-slug");
    let origin = e.currentTarget.getAttribute("data-analytics-origin");

    if (this.nftContractIds.includes(nftContractId)) {
      Toaster.toast(I18n.t("portfolio.add_nft.already_added"));
      return;
    }

    this.loadingTarget.classList.remove("!tw-hidden");

    const url = `/en/nft-portfolios/${this.nftPortfolioId}/nfts/${nftContractId}`;
    fetch(url, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-CSRF-Token": getCSRFToken(),
      }
    }).then((response) => {
      if (!response.ok) {
        Toaster.toast("An unknown error occurred", { icon: { classes: "fas fa-times tw-text-danger-500" } });
      } else {
        window.location.reload();
      }
    })

    trackEvent(SELECT_ADD_PORTFOLIO_NFT_CTA, { origin, nft_name: nftSlug })
  }
}
